var $297b9162861805d5$exports = {};
$297b9162861805d5$exports = {
    "loading": `Se \xeencarc\u{103}...`,
    "placeholder": `Selecta\u{21B}i\u{2026}`
};


export {$297b9162861805d5$exports as default};
//# sourceMappingURL=ro-RO.mjs.map
